import { AccountService } from '@/app/shared/services/account.service';
import { Component, ViewChild } from '@angular/core';
import { TOKEN } from '@/app/shared/services/auth.service';
import { TransferState } from '@angular/core';
import { CommonService } from '@/app/shared/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationModalComponent } from '@/app/shared/widgets/modal/confirmation-modal/confirmation-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SsrCookieService } from 'ngx-cookie-service-ssr';

@Component({
  selector: 'app-companion',
  templateUrl: './companion.component.html',
  styleUrl: './companion.component.scss'
})
export class CompanionComponent {

  programs: any[];
  currentUserName: string = '';

  modalTitle: string = '';
  modalMessage: string = '';
  selectedProgramId: string | null = null;

  constructor(
    private accountService: AccountService,
    private transferState: TransferState,
    private commonService: CommonService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private cookieService: SsrCookieService
  ) { }

  @ViewChild('confirmModal') confirmModal: ConfirmationModalComponent;
  ngOnInit() {
    // this.getCompanions();

    const token = this.cookieService.get('token');
    let jwtToken = this.commonService.parseJwt(token!);
    let userName = jwtToken?.UserName;
    this.currentUserName = userName;
    if (userName) {
      this.getMembershipPrograms(userName);
    }
  }

  getMembershipPrograms(userName: string) {
    this.accountService.getMembershipPrograms(userName).subscribe({
      next: (res: any) => {
        if (res) {
          this.programs = res;

          this.route.queryParams.subscribe(params => {
            const registerProgramId = params['registerProgramId'];
            if (registerProgramId) {
              if (this.programs?.length) {
                const matchedProgram = this.programs.find(p => p.id === registerProgramId);
                if (matchedProgram) {
                  this.openConfirmModal(matchedProgram);
                }
              }
            }
          });
        }
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  openConfirmModal(program: any) {
    this.modalTitle = 'Xác nhận đăng ký';
    this.modalMessage = `
      <div style="font-size: 1rem; line-height: 1.8; padding: 0 8px; text-align: justify;">
        <p style="margin-bottom: 10px;">
          <strong>Xem thông tin chi tiết chương trình:</strong>
          <a href="${program.detailLink}" target="_blank" style="color: #1e88e5; text-decoration: underline;">Tại đây</a>
        </p>
        <p style="margin-bottom: 10px;">
          Tôi xác nhận đã đọc và đồng ý với <strong>các quyền lợi, điều kiện, và quy định</strong> của chương trình
          <strong>Đồng hành cùng Dược Vương</strong>.
        </p>
        <p>
          Tôi đăng ký tham gia chương trình và <strong>cam kết tuân thủ</strong> các điều kiện, quy định của chương trình do Dược Vương ban hành.
        </p>
      </div>
    `;
    this.selectedProgramId = program.id;
    this.confirmModal.openModal();
  }

  viewDetails(detailPageUrl: string) {
    // Logic to redirect to the event details page
    window.open(detailPageUrl, '_blank');
  }
}
